import React, { Component } from 'react';
import DataList from 'components/ui/DataList';
import DataPoller from 'components/ui/DataPoller';
import ConfirmModal from 'components/ui/modals/ConfirmModal';
import LocationActionCreators from 'actions/LocationActionCreators';
import LocationStore from 'stores/LocationStore';
import SessionStore from 'stores/SessionStore';
import Roles from 'constants/UserRoles';
import { withTranslation } from 'react-i18next';
import CreateLocationPairModal from './CreateLocationPairModal';
import Mapping from './LocationPairMapping';
const editRoles = [Roles.LOCATIONS_ADMIN, Roles.LOCATIONS_MANAGER, Roles.GOD];
const deleteRoles = [Roles.LOCATIONS_ADMIN, Roles.GOD];
function mapRoles() {
    const roles = SessionStore.getUserRoles();
    const canEdit = roles.some((r) => editRoles.includes(r));
    const canDelete = roles.some((r) => deleteRoles.includes(r));
    return {
        canEdit,
        canDelete,
    };
}
class LocationPairList extends Component {
    constructor(props) {
        super(props);
        this.handleLocationStoreChange = () => {
            const locationPairs = LocationStore.getLocationPairs();
            console.log(locationPairs);
            const locationPairsResult = LocationStore.getLocationPairsResult();
            const errors = LocationStore.getLocationPairsError();
            this.setState({
                locationPairs,
                errors,
                totalPages: locationPairsResult.pages,
            });
        };
        this.handleSessionStoreChange = () => {
            this.setState(Object.assign({}, mapRoles()), () => this.handleRolesUpdated);
        };
        this.handleRolesUpdated = () => {
            const { canEdit, canDelete } = this.state;
            this.columnMappings = Mapping.columns.map((col) => {
                if (col.type === 'customActions') {
                    return Object.assign(Object.assign({}, col), { formatExtraData: {
                            onEdit: this.handleEdit,
                            onDelete: this.handleDelete,
                            canEdit,
                            canDelete,
                        } });
                }
                return col;
            });
        };
        this.handleAddLocationPair = (e) => {
            e.preventDefault();
            this.setState({
                currentLocationPair: null,
                showCreateLocationPairModal: true,
            });
        };
        this.handleHideCreateLocationPairModal = () => this.setState({
            currentLocationPair: null,
            showCreateLocationPairModal: false,
        });
        this.handleSaveLocationPair = (locationPair) => {
            if (!locationPair._id) {
                delete locationPair._id;
                LocationActionCreators.createLocationPair(locationPair);
            }
            else {
                const id = locationPair._id;
                delete locationPair._id;
                LocationActionCreators.updateLocationPair(id, locationPair);
            }
            this.handleHideCreateLocationPairModal();
        };
        this.handleConfirmDelete = () => {
            LocationActionCreators.removeLocationPair(this.state.currentLocationPair._id);
            this.handleHideConfirmModal();
        };
        this.handleDelete = (row) => {
            this.setState({
                currentLocationPair: row,
                showConfirmModal: true,
            });
        };
        this.handleHideConfirmModal = () => {
            this.setState({
                showConfirmModal: false,
                currentLocationPair: null,
            });
        };
        this.handleEdit = (row) => {
            this.setState({
                currentLocationPair: row,
                showCreateLocationPairModal: true,
            });
        };
        this.handlePaginationSelect = (page) => {
            let filters;
            this.setState((prevState) => {
                filters = prevState.filters;
                filters.page = page;
                return { filters };
            }, () => {
                LocationActionCreators.getLocationPairs(filters);
            });
        };
        this.state = Object.assign({ errors: {}, locationPairs: [], totalPages: 10, filters: {
                page: 1,
                per_page: 25,
                paginate: true,
                sort_by: '_id',
            }, currentLocationPair: null, showConfirmModal: false, showCreateLocationPairModal: false }, mapRoles());
        const { canEdit, canDelete } = this.state;
        this.columnMappings = Mapping.columns.map((col) => {
            if (col.type === 'customActions') {
                return Object.assign(Object.assign({}, col), { formatExtraData: {
                        onEdit: this.handleEdit,
                        onDelete: this.handleDelete,
                        canEdit,
                        canDelete,
                    } });
            }
            return col;
        });
    }
    componentDidMount() {
        LocationStore.addChangeListener(this.handleLocationStoreChange);
        SessionStore.addChangeListener(this.handleSessionStoreChange);
    }
    componentWillUnmount() {
        LocationStore.removeChangeListener(this.handleLocationStoreChange);
        SessionStore.removeChangeListener(this.handleSessionStoreChange);
    }
    render() {
        const { t } = this.props;
        return (React.createElement("div", { className: "p-4 mb-4 bg-white rounded shadow wrapper" },
            React.createElement("header", { className: "flex items-center mb-4" },
                React.createElement("h3", { className: "mt-0 mb-0 mr-2" }, t('LOCATION_PAIRS')),
                this.state.canEdit && (React.createElement("button", { title: t('CREATE_LOCATION_PAIR'), className: "flex items-center text-white button button-circle bg-green", onClick: this.handleAddLocationPair },
                    React.createElement("i", { className: "mr-0 fa fa-plus" })))),
            React.createElement(DataPoller, { action: () => LocationActionCreators.getLocationPairs(this.state.filters) }),
            React.createElement(DataList, { striped: true, showHeaders: true, paginate: true, data: this.state.locationPairs || [], columns: this.columnMappings, pages: this.state.totalPages, page: this.state.filters.page, onPaginationSelect: this.handlePaginationSelect }),
            React.createElement(CreateLocationPairModal, { show: this.state.showCreateLocationPairModal, locationPair: this.state.currentLocationPair, onHide: this.handleHideCreateLocationPairModal, onSave: this.handleSaveLocationPair }),
            React.createElement(ConfirmModal, { show: this.state.showConfirmModal, title: t('DELETE_CONFIRMATION'), message: t('DELETE_LOCATION_PAIR_CONFIRMATION'), onConfirm: this.handleConfirmDelete, onHide: this.handleHideConfirmModal })));
    }
}
export default withTranslation()(LocationPairList);
